import type { TCompanyGroupDto } from '@homepal/api-contract'

export enum GlobalFilterVariant {
  ALL = 'all',
  STANDARD = 'standard',
  CUSTOM = 'custom',
  COMPANY_GROUP = 'company_group'
}

export type TGlobalFilterSelected = {
  variant: GlobalFilterVariant
  customSelected: string[]
  companyGroup: TCompanyGroupDto | null
  isInitialized: boolean
}

export type TGlobalFilterApiInput = {
  company_group_id: string | null
  convert_to_currency?: string | null
  custom_selected: string[]
  variant: GlobalFilterVariant
}
